<template>
  <div class="w-full max-w-2xl" :dir="isRtl === true ? 'rtl' : 'ltr'">
    <div class="rounded-2xl border border-stone-200 bg-white/90 p-5 shadow-sm dark:border-stone-700 dark:bg-stone-900/70">
      <label class="label pt-0">
        <span class="label-text font-medium">{{ t('agentCreate.organization.name', 'Organization name') }}</span>
      </label>
      <input v-model="organizationName" type="text" class="input input-bordered w-full" :placeholder="t('agentCreate.organization.namePlaceholder', 'e.g. Acme Health')" @input="emitChange" />

      <label class="label mt-4">
        <span class="label-text font-medium">{{ t('agentCreate.organization.description', 'What does this organization do?') }}</span>
      </label>
      <textarea v-model="organizationDescription" rows="7" class="textarea textarea-bordered w-full" :placeholder="t('agentCreate.organization.descriptionPlaceholder', 'Describe its customers, services, policies, and how the agent should represent it.')" @input="emitChange"></textarea>
      <p class="mt-2 text-sm text-slate-500 dark:text-slate-400">{{ t('agentCreate.organization.hint', 'This information is used to build the agent instructions and rules.') }}</p>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from '@/i18n';

const emit = defineEmits(['update:organization']);
const { t, currentLanguage, availableLanguages } = useI18n();
const organizationName = ref('');
const organizationDescription = ref('');

const isRtl = computed(() => {
  const language = availableLanguages.value.find((item) => item.code === currentLanguage.value);
  if (language === undefined || language === null) {
    return false;
  }
  return language.dir === 'rtl';
});

function buildPayload() {
  return {
    name: organizationName.value.trim(),
    description: organizationDescription.value.trim()
  };
}

function emitChange() {
  emit('update:organization', buildPayload());
}

function isReady() {
  return organizationName.value.trim().length > 0 && organizationDescription.value.trim().length >= 8;
}

defineExpose({
  buildPayload,
  isReady
});
</script>
